import { useTranslation } from 'react-i18next'
import { ClerkSignInWithMobileSupport } from '@/components/auth/ClerkSignInWithMobileSupport'
import { useMobileDetection } from '@/hooks/useMobileDetection'
import { Logo } from '@/components/ui'

export function SignInPage() {
  const { t } = useTranslation()
  const { isMobile } = useMobileDetection()

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-blue-50 via-white to-indigo-50 px-4 py-12 sm:px-6 lg:px-8">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center">
          <Logo variant="full" size="lg" className="mx-auto" />
          <p className="mt-4 text-sm text-gray-600">
            {t('auth.signInSubtitle')}
          </p>
        </div>

        <ClerkSignInWithMobileSupport
          routing="path"
          path="/sign-in"
          signUpUrl="/sign-up"
          afterSignInUrl="/dashboard"
        />

        {/* Mobile hint */}
        {isMobile && (
          <div className="text-center text-xs text-gray-500">
            <p>{t('auth.mobileAppHint')}</p>
          </div>
        )}
      </div>
    </div>
  )
}